import React from 'react'

const LightningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3656 7.8413L6.36559 15.3413C6.29141 15.4205 6.19349 15.4734 6.08661 15.492C5.97974 15.5106 5.8697 15.494 5.7731 15.4446C5.67651 15.3952 5.5986 15.3157 5.55113 15.2182C5.50366 15.1206 5.48921 15.0103 5.50996 14.9038L6.42621 10.3207L2.82434 8.96818C2.74698 8.93924 2.678 8.8916 2.62355 8.8295C2.5691 8.7674 2.53089 8.69277 2.51232 8.6123C2.49374 8.53183 2.4954 8.448 2.51713 8.36832C2.53886 8.28864 2.57998 8.21559 2.63684 8.15568L9.63684 0.655679C9.71102 0.576514 9.80893 0.523624 9.91581 0.50499C10.0227 0.486356 10.1327 0.502989 10.2293 0.55238C10.3259 0.601771 10.4038 0.681239 10.4513 0.778793C10.4988 0.876346 10.5132 0.986692 10.4925 1.09318L9.57371 5.6813L13.1756 7.03193C13.2524 7.06106 13.3208 7.10865 13.3748 7.17051C13.4288 7.23236 13.4668 7.30657 13.4853 7.38658C13.5039 7.46658 13.5024 7.54992 13.4811 7.62923C13.4598 7.70854 13.4192 7.78138 13.3631 7.8413H13.3656Z"
        fill="#635CFF"
      />
    </svg>
  )
}

export default LightningIcon
